export enum ChatMessageAuthorRole {
    CUSTOMER = "CUSTOMER",
    MERCHANT = "MERCHANT",
}

export enum UserType {
    USER = "USER",
    MERCHANT = "MERCHANT",
}

export enum ChatChannel {
    ORDER_CHAT = "ORDER_CHAT",
}

export enum MessageDirection {
    SENT = "SENT",
    RECEIVED = "RECEIVED",
}

export type ChatMessageSender =
    | Readonly<{
          type: UserType.MERCHANT
          merchantId: number
          userId: number
      }>
    | Readonly<{
          type: UserType.USER
          companyId: number
          userId: number
      }>

type MerchantSenderPayload = {
    type: UserType.MERCHANT
    merchant: { id: number }
    user: { id: number }
}

type UserSenderPayload = {
    type: UserType.USER
    company: { id: number }
    user: { id: number }
}

export type ChatMessagePayload = Readonly<{
    body: string
    sender?: MerchantSenderPayload | UserSenderPayload
    channels: ChatChannel[]
}>

export type ChatMessage = Readonly<{
    id: number
    creator: {
        id: number
        userType: UserType
        displayName: string
    }
    recipient: {
        id: number
    }
    messageDirection: MessageDirection
    subject?: string
    body: string
    created: string
}>

export type OrderChatResponse = Readonly<{
    messages: ChatMessage[]
}>

export type ChatOrder = Readonly<{
    id: number
    title?: string
}>

export type SendChatMessageParams = Readonly<{
    orderId: number
    payload: ChatMessagePayload
}>

export enum ChatIconVariant {
    NEEDS_RESPONSE = "needsResponse",
    RESPONDED = "responded",
}

export function getChatIconVariant(messages: ChatMessage[] | undefined): ChatIconVariant | null {
    if (!messages || messages.length === 0) return null
    return messages[0].messageDirection === MessageDirection.RECEIVED
        ? ChatIconVariant.NEEDS_RESPONSE
        : ChatIconVariant.RESPONDED
}
